// Kyrgyz MSISDN helpers shared by the landing pages (carrier detection lives in ./carrier).

// National 9-digit number from whatever the visitor typed: 9 digits, 0 + 9 digits (a leading trunk
// zero), or 996 + 9 digits. Anything else (too short, too long, 9 digits starting with 0) is invalid.
export function toNationalNumber(raw) {
  const digits = String(raw ?? '').replace(/\D/g, '');
  if (digits.length === 12 && digits.startsWith('996')) return digits.slice(3);
  if (digits.length === 10 && digits.startsWith('0')) return digits.slice(1);
  if (digits.length === 9 && !digits.startsWith('0')) return digits;
  return null;
}

// Digits-only input value, capped at 9 digits (10 when it starts with the trunk zero).
export function sanitizeMsisdnInput(raw) {
  const digits = String(raw ?? '').replace(/\D/g, '');
  return digits.slice(0, digits.startsWith('0') ? 10 : 9);
}
